import DevicesRepository from '@/api/repositories/devices.repository';
import MovesRepository from '@/api/repositories/moves.repository';
import NotificationsRepository from '@/api/repositories/notifications.repository';
import AuthRepository from '@/api/repositories/auth.repository';
import SettingsRepository from '@/api/repositories/settings.repository';

export default {
  devices: DevicesRepository,
  moves: MovesRepository,
  notifications: NotificationsRepository,
  auth: AuthRepository,
  settings: SettingsRepository,
};
